export default __webpack_public_path__ + "static/media/img_chart_grade_A0.552e605e3a0db37ec2d48a8ac2fdd8d9.svg";